
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";

  import GET_MANAGER_PROFILE from "@/apollo/profile/manager/GetManagerProfile.gql";
  import UPDATE_MANAGER_PROFILE from "@/apollo/profile/manager/UpdateManagerProfile.gql";

  import FormGroup from "@/components/form/FormGroup.vue";
  import FormTextarea from "@/components/form/FormTextarea.vue";
  import FormWrapper from "@/components/form/FormWrapper.vue";
  import UiButton from '@/components/button/ui-button.vue';
  import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselect.vue";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

  import {
    User_Profile,
    User_Skill,
  } from "@/generated/graphql";
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";

  @Component({
    components: {
      FormGroup,
      FormTextarea,
      FormWrapper,
      UiButton,
      SkillsMultiselect,
      LoadingOverlay,
    },
    apollo: {
      profile: {
        query: GET_MANAGER_PROFILE,
        variables() {
          return {
            id: this.userId,
          };
        },
        update: (data) => {
          return data.user_profile_by_pk;
        },
      },
    },
  })
  export default class AdditionalData extends Vue {
    @Prop({ type: String, required: true }) readonly userId!: string;

    profile?: User_Profile = undefined;

    skillsIds: number[] = [];

    @Watch("profile")
    watchProfile(profile: User_Profile) {
      this.skillsIds = profile.skills.map(({ skill }) => skill.id);
    }

    get userSkills(): Partial<User_Skill>[] {
      return this.skillsIds.map((skillId) => ({
        user_id: this.userId,
        skill_id: skillId,
      }));
    }

    async updateProfile(): Promise<void> {
      try {
        await this.update();

        this.$eventBus.emit(NOTIFICATION, Message.successMessage("Updated"));
        this.refetch();
      } catch (error) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(error.message));
      }
    }

    async update(): Promise<void> {
      await this.$apollo.mutate({
        mutation: UPDATE_MANAGER_PROFILE,
        variables: {
          userId: this.userId,
          userProfileSet: {
            about: this.profile?.about || null,
          },
          userSkillSet: this.userSkills,
        },
      });
    }

    refetch(): void {
      this.$apollo.queries.profile.refetch();
      this.$emit("update");
    }
  }
